/**
 * Utitlies for rendering and managing client side alerts
 * @type {Object}
 */
Mmg.Alert = {

	$container: null,

	labels: {
		'success': 'SUCCESS',
		'info': 'INFO',
		'warning': 'NOTICE',
		'danger': 'ERROR'
	},

	// TODO: Convert to es6 template literal
	template: '<div class="alert alert-${level} mmg-alert ${class}"><b>${label}:</b> ${message}</div>',


	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	init: function(){
		this.$container = jQuery('<div>').addClass('mmg-alert-container');
		jQuery('body').prepend(this.$container.hide());
		this.$container.delay(100).slideDown();
	},


	/**
	 * [render description]
	 * @param  {[type]} message [description]
	 * @param  {[type]} options [description]
	 * @return {[type]}         [description]
	 */
	render: function(message, options){

		var defaultLevel = 'danger',
			params = jQuery.extend({
				level: defaultLevel,
				class: ''
			}, options)
		;

		// TODO: Use modern js to render the template
		return this.template
				.replace('${level}', params.level)
				.replace('${class}', params.class)
				.replace('${label}', this.labels[params.level])
				.replace('${message}', message);
	},


	/**
	 * [add description]
	 * @param {[type]} message [description]
	 * @param {[type]} options [description]
	 */
	add: function(message, options){
		if(!this.$container){
			this.init();
		}

		this.$container.append(this.render(message, options));
	},


	/**
	 * [remove description]
	 * @return {[type]} [description]
	 */
	remove: function(){

		var namespace = arguments[0] || '*';

		if(!this.$container){
			return;
		}

		this.$container.find(' > .' + namespace).remove();
	},

};
